<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class=WordSection1>

  <p class=MsoNormal style='text-align:center'><strong><span lang=FR-CH
                                                             style='font-size:15.0pt;font-family:"Times New Roman", sans-serif;color:#1F4E79'>Provalt
Equarrissage Web et Mobile (iOS / Android)</span></strong></p>

  <p class=MsoNormal style='text-align:center'><strong><span lang=FR-CH
                                                             style='font-size:15.0pt;font-family:"Times New Roman", sans-serif;color:#1F4E79'>Conditions
générales d’utilisation</span></strong></p>

  <p class=MsoNormal><span lang=FR-CH style='font-size:10.0pt'>&nbsp;</span></p>

  <p class=MsoListParagraph style='text-indent:-18.0pt'><strong><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>1.<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></strong><strong><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>GENERAL</span></strong></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-indent:-18.0pt'><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;color:#242424'>1.1<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp; </span></span><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;color:#242424'>&nbsp;Les
présentes Conditions Générales ont pour objet de définir les modalités de mise
à disposition des services du service
Provalt Equarrissage, ci-après nommé « le Service » et les conditions
d'utilisation du Site par l'Utilisateur. </span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-indent:-18.0pt'><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;color:#242424'>1.2<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp; </span></span><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;color:#242424'>Tout accès
et/ou Utilisation du service Provalt Equarrissage suppose l'acceptation et le
respect de l'ensemble des termes des présentes Conditions et leur acceptation
inconditionnelle. Elles constituent donc un contrat entre le fournisseur du Service
et l'Utilisateur.</span></p>

  <p class=MsoNormal style='text-align:justify'><strong><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;'>&nbsp;</span></strong></p>

  <p class=MsoListParagraph style='text-indent:-18.0pt'><strong><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>2.<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></strong><strong><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>DEFINITIONS</span></strong></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#242424'>2.1<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>On entend par «&nbsp;<strong>Utilisateur&nbsp;»</strong></span><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;color:#242424'> toute
personne qui utilise le Service Web et/ou mobile (application iOS / Android).</span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#242424'>2.2<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>La syntagme «&nbsp;<strong>Contenu utilisateur&nbsp;»</strong></span><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;color:#242424'> désigne
les données transmises par l'Utilisateur dans les différentes rubriques du Service.</span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#242424'>2.3<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>Le terme <strong>« Membre</strong> » désigne un utilisateur identifié sur
le Service.</span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#242424'>2.4<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>Le terme « <strong>Identifiant</strong> » recouvre les informations
nécessaires à l'identification d'un utilisateur sur le Service pour accéder aux
zones réservées aux membres.</span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#242424'>2.5<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>Le « <strong>Mot de passe</strong> » est une information confidentielle,
dont l'Utilisateur doit garder le secret, lui permettant, utilisé conjointement
avec son Identifiant, de prouver l'identité.</span></p>

  <p class=MsoNormal><span lang=FR-CH style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;</span>
  </p>

  <p class=MsoListParagraph style='text-indent:-18.0pt'><strong><span lang=FR-CH
                                                                      style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>3.<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></strong><strong><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>DISPONIBILITE</span></strong></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#242424'>3.1<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>Le Service est accessible gratuitement à tout Utilisateur
disposant d'un accès à internet. Tous les coûts afférents à l'accès au Service,
que ce soient les frais matériels, logiciels ou d'accès à internet sont
exclusivement à la charge de l'utilisateur. Il est seul responsable du bon
fonctionnement de son équipement informatique ainsi que de son accès à
internet. </span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#242424'>3.2<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>Certaines sections du Service sont réservées aux Membres après
identification à l'aide de leur Identifiant et de leur Mot de passe. </span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#242424'>3.3<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>Provalt Equarrissage se réserve le droit de refuser l'accès au Service,
unilatéralement et sans notification préalable, à tout Utilisateur ne
respectant pas les présentes conditions d'utilisation. </span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#242424'>3.4<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>Provalt Equarrissage met en œuvre tous les moyens raisonnables à
sa disposition pour assurer un accès de qualité au Service. </span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#242424'>3.5<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>Provalt Equarrissage ne peut, en outre, être tenue responsable
de tout dysfonctionnement du réseau ou des opérateurs ou de tout autre
événement échappant à son contrôle raisonnable, qui empêcherait ou dégraderait
l'accès au Service. </span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#242424'>3.6<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>Provalt Equarrissage se réserve la possibilité d'interrompre, de
suspendre momentanément ou de modifier sans préavis l'accès à tout ou partie du
Service, afin d'en assurer la maintenance, ou pour toute autre raison, sans que
l'interruption ne donne droit à aucune obligation ni indemnisation.</span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-autospace:none'><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;color:#242424'>&nbsp;</span></p>

  <p class=MsoListParagraph style='text-indent:-18.0pt'><strong><span lang=FR-CH
                                                                      style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>4.<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></strong><strong><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>DROITS&nbsp;DE PROPRIETE
INTELLECTUELLE&nbsp;ET LICENCE</span></strong></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt'><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>4.1<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp; </span></span><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>Toutes les marques,
déposées ou non, les signes commerciaux, logos, les raisons de commerce, les
droits d’auteur, tous les droits relatifs aux bases de données et tout autre
droit de propriété intellectuelle de quelque nature que ce soit, ainsi que ceux
se rapportant au code logiciel sous-jacent, sont la propriété du détenteur du <span
      style='color:#242424'>service Provalt Equarrissage. </span>Les droits découlant
des licences que le détenteur peut accorder aux partenaires restent réservés. </span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt'><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>4.2<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp; </span></span><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;color:#242424'>L'Utilisateur
est seul responsable du Contenu Utilisateur qu'il met en ligne via le Service. Il
s'engage notamment à ce que ces données ne soient pas de nature à porter
atteinte aux intérêts légitimes de tiers quels qu'ils soient. A ce titre, il
garantit Provalt Equarrissage contre tous recours, fondés directement ou
indirectement sur ces propos et/ou données, susceptibles d'être intentés par
quiconque à l'encontre de Provalt Equarrissage. Il s'engage en particulier à
prendre en charge le paiement des sommes, quelles qu'elles soient, résultant du
recours d'un tiers à l'encontre de Provalt Equarrissage, y compris les
honoraires d'avocat et frais de justice. </span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt'><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>4.3<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp; </span></span><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;color:#242424'>Provalt
Equarrissage se réserve le droit de supprimer tout ou partie du Contenu
Utilisateur, à tout moment et pour quelque raison que ce soit, sans
avertissement ou justification préalable. L'Utilisateur ne pourra faire valoir
aucune réclamation à ce titre.</span></p>

  <p class=MsoListParagraph style='text-align:justify'><span style='font-size:
10.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;</span></p>

  <p class=MsoListParagraph style='text-indent:-18.0pt'><strong><span lang=FR-CH
                                                                      style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>5.<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></strong><strong><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>PROTECTION&nbsp;DES
DONNEES</span></strong></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#242424'>5.1<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>En délégation du service publique, Provalt Equarrissage s'engage
à ce que la collecte et le traitement des données personnelles, effectués au
sein du présent site, soient effectués conformément à la loi n°78-17 du 6
janvier 1978 relative à l'informatique, aux fichiers et aux libertés, selon ses
modifications de 2014. </span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#242424'>5.2<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>Conformément à l'article 57 de la loi n°78-17, Provalt
Equarrissage garantit à l'Utilisateur un droit d'opposition, d'accès, de
rectification et de suppression sur les données personnelles le concernant. Les
prévisions du Chapitre IV de l’annexe 2 du Règlement (CE) 1774/2002 du 3
octobre 2002, aussi que les normes légales en vigueur en France concernant la
santé et la sécurité publique, sont réservés. </span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#242424'>5.3<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>Les informations
personnelles que vous fournissez à travers du <span style='color:#242424'>service
Provalt Equarrissage</span> sont protégés conformément à sa politique de
confidentialité (disponible sur le site internet https://provalt.fr). </span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-autospace:none'><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;color:#242424'>&nbsp;</span></p>

  <p class=MsoListParagraph style='text-indent:-18.0pt'><strong><span lang=FR-CH
                                                                      style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>6.<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></strong><strong><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>LIMITATION&nbsp;DE
RESPONSABILITE</span></strong></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#242424'>6.1<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>Conformément à son politique de confidentialité, Provalt Equarrissage s'engage à mettre
en place tous les moyens nécessaires pour garantir la sécurité et la
confidentialité des données transmises. </span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#242424'>6.2<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>L'Utilisateur admet connaître les limitations et contraintes
propres au réseau internet et, à ce titre, reconnaît notamment l'impossibilité
d'une garantie totale de la sécurisation des échanges de données.</span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#242424'>6.3<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>Provalt Equarrissage ne pourra pas être tenue responsable des
préjudices découlant de la transmission de toute information, y compris de
celle de son identifiant et/ou de son mot de passe, via le Service. </span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#242424'>6.4<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>Provalt Equarrissage ne pourra en aucun cas, dans la limite du
droit applicable, être tenue responsable des dommages et/ou préjudices, directs
ou indirects, matériels ou immatériels, ou de quelque nature que ce soit,
résultant d'une indisponibilité du Service ou de toute Utilisation du Service.
Le terme « Utilisation » doit être entendu au sens large, c'est-à-dire tout
usage du Service quel qu'il soit, licite ou non. </span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#242424'>6.5<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>L'Utilisateur s'engage, d'une manière générale, à respecter l'ensemble
de la réglementation en vigueur en France. </span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;color:#242424'>6.6<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>Provalt Equarrissage </span><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;'>n’est pas responsable de dommages ou altérations
de l’équipement, sans limitation, tout équipement informatique, terminaux
mobiles ou téléphones portables, suite à l’utilisation du Service. </span></p>

  <p class=MsoNormal style='text-align:justify'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;'>&nbsp;</span></p>

  <p class=MsoListParagraph style='text-indent:-18.0pt;text-autospace:none'><strong><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;color:#242424'>7.<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></strong><strong><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;color:#242424'>FORCE
MAJEURE</span></strong></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt'><span lang=FR-CH style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>7.1<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp; </span></span><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;color:#242424'>La
responsabilité de Provalt Equarrissage ne pourra être engagée en cas de force
majeure ou de faits indépendants de sa volonté.</span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt'><span lang=FR-CH
                                                             style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;</span>
  </p>

  <p class=MsoListParagraph style='text-indent:-18.0pt'><strong><span lang=FR-CH
                                                                      style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>8.<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></strong><strong><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>RESILIATION</span></strong></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt'><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>8.1<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp; </span></span><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;color:#242424'>Le présent
contrat est conclu pour une durée indéterminée à compter de l'Utilisation du Service
par l'Utilisateur, pour des raisons de suivi sanitaire. </span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt'><span style='font-size:
10.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;</span></p>

  <p class=MsoListParagraph style='text-indent:-18.0pt'><strong><span lang=FR-CH
                                                                      style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>9.<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;&nbsp;&nbsp; </span></span></strong><strong><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>UTILISATION DU SITE OPPOSABLE</span></strong>
  </p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;'>9.1<span style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>Provalt Equarrissage se réserve le droit de modifier les termes,
conditions et mentions du présent contrat à tout moment. Il est ainsi conseillé
à l'Utilisateur de consulter régulièrement la dernière version des Conditions d'Utilisation
disponible sur Provalt Equarrissage Web.</span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt;text-autospace:none'><span style='font-size:10.0pt;
font-family:"Times New Roman", sans-serif;'>9.2<span style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp;
</span></span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>Les
conditions ci-dessus sont censés connues et acceptés. Nul ne peut se prévaloir
de sa méconnaissance pour une action contre les entreprises présentés via </span><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;color:#242424'>Provalt
Equarrissage.</span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt'><span lang=FR-CH
                                                             style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;</span>
  </p>

  <p class=MsoListParagraph style='text-indent:-18.0pt'><strong><span lang=FR-CH
                                                                      style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>10.<span
    style='font-size:7.0pt;font-family:"Times New Roman", sans-serif;'>&nbsp;&nbsp; </span></span></strong><strong><span
    style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;'>DROIT APPLICABLE ET
JURISDICTION COMPETENTE </span></strong></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt'><span lang=FR-CH style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>10.1</span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>Les règles en matière de droit, applicables aux contenus et aux
transmissions de données sur et autour du service, sont déterminées par la loi
française. </span></p>

  <p class=MsoListParagraph style='margin-left:18.0pt;text-align:justify;
text-indent:-18.0pt'><span lang=FR-CH style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>10.2</span><span style='font-size:10.0pt;font-family:"Times New Roman", sans-serif;
color:#242424'>En cas de litige, n'ayant pu faire l'objet d'un accord à
l'amiable, seuls les tribunaux français sont compétents.</span></p>

  <p class=MsoNormal><span lang=FR-CH>&nbsp;</span></p>

  <p class=MsoNormal style='text-align:right'><em><span lang=FR-CH
                                                        style='font-family:"Times New Roman", sans-serif;'>Dernière mise à jour&nbsp;: 31 janvier
2017</span></em></p>

</div>
